import { useTranslation } from '@dreamstack/i18n'
import type { FunctionComponent } from 'react'
import { GridWithGapsAndPadding } from '../layout/MainGrid'
import { BodyText, HeadingH1 } from '../layout/Texts'
import { useNewsletterForm } from './useNewsletterForm'

type NewsletterFormData = {
  title: string
  foreame: string
  surname: string
  agreeToLegalImprint: boolean
  lang: 'de' | 'en'
  email: string
}

export const newsletterInputClassName = 'newsletter-email-input' as const

export const Newsletter: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  const t = useTranslation()
  const {
    FormFields,
    formProps,
    FormProvider,
    formProviderProps,
    SuccessDialog,
  } = useNewsletterForm()
  // TODO: Prefill form data if logged in.
  return (
    <div className="bg-accentroGray-full text-accentroWhite-full">
      {SuccessDialog}
      <GridWithGapsAndPadding className="mt-px-64 md:mt-px-80 ml:mt-px-96">
        <div className="col-span-full">
          <FormProvider {...formProviderProps}>
            <form {...formProps}>
              <HeadingH1
                id="newsletter"
                className="mt-px-48 ml:mt-px-80 lg:mt-px-128"
              >
                {t('accentro:newsletter')}
              </HeadingH1>
              <div className="grid grid-cols-1 gap-px-32 mt-px-24 md:grid-cols-2 md:mt-px-48 md:gap-px-48 lg:mt-px-96 lg:gap-px-64">
                <div>
                  <BodyText>{t('accentro:formTexts.newsletterBody')}</BodyText>
                </div>
                {FormFields}
              </div>
            </form>
          </FormProvider>
          <div className="h-px bg-accentroWhite-500 mt-px-80 lg:mt-px-96" />
        </div>
      </GridWithGapsAndPadding>
    </div>
  )
}
